import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import * as firebase from 'firebase';

var config = {
  apiKey: "AIzaSyC3RhN3wCMrdWGFVAHEL-VXacTXu8lU0LE",
  authDomain: "ctfskillz.firebaseapp.com",
  databaseURL: "https://ctfskillz.firebaseio.com",
  projectId: "ctfskillz",
  storageBucket: "ctfskillz.appspot.com",
  messagingSenderId: "31822497799"
};
firebase.initializeApp(config);

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js